var React = require('react');

function InputArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m4.5 12h15m0 0-6.75-6.75m6.75 6.75-6.75 6.75","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

InputArrowRight.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = InputArrowRight;

InputArrowRight.default = InputArrowRight;
